import { createClient } from '@supabase/supabase-js';

// Usado SÓ para autenticação (login por OTP, sessão, logout) — nenhum dado
// de venda/afiliado é lido daqui. A leitura de dados sempre passa pelo
// Worker (ver src/lib/api.ts), que aplica o isolamento por afiliado no
// backend. A chave usada aqui é a "anon"/"publishable" (pública por
// design) — nunca a service_role/secret key, que nunca aparece em nenhum
// código do navegador.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error('VITE_SUPABASE_URL/VITE_SUPABASE_ANON_KEY não configuradas. Login não vai funcionar.');
}

export const supabase = createClient(supabaseUrl ?? '', supabaseAnonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
